import React, { useMemo, } from 'react';
import PropTypes from 'prop-types';
import { ReactTemplate } from '@bingads-webui-react/react-template';

const noTranslateModel = { noTranslate: text => (<a id="historyPageLink" href="">{text}</a>) };

export const BulkMMAConvertProgress = ({
  onHide, i18n, show, totalCount, completeCount,
}) => {
  const completePercentage = useMemo(() => {
    const total = totalCount;
    if (total === 0) {
      return '1%';
    }

    const completed = Math.floor((completeCount * 100) / total);
    return completed < 1 ? `${completed + 1}%` : `${completed}%`;
  }, [completeCount, totalCount]);

  if (!show) {
    return null;
  }

  const messageTemplate = i18n.getString(_TL_('You can see a summary of your changes on the {{noTranslate}}Bulk Edits{{/noTranslate}} page.'));

  return (
    <div className="panel-body" role="alert">
      <div>{i18n.getString('BulkEdit_InitialStatus')}</div>
      <div className="bulk-edit-progress-bar">
        <div className="progress">
          <div className="progress-bar" ariaValuenow={completePercentage} style={{ width: completePercentage }} />
          <div role="progressbar" ariaValuemin="0%" ariaValuemax="100%" />
        </div>
        <div className="bulkeditlink">
          <ReactTemplate
            model={noTranslateModel}
            template={messageTemplate}
          />
        </div>
        <button id="runInBackground" className="btn btn-default" onClick={onHide}>{i18n.getString('BulkEdit_RunInBackground')}</button>
      </div>
    </div>
  );
};

BulkMMAConvertProgress.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  completeCount: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
};

BulkMMAConvertProgress.defaultProps = {
};
